import AOS from 'aos';

$(function() {
    // AOS
    AOS.init({
        duration: 800,
        easing: 'ease-out-cubic',
        once: true,
        offset: 100
    });

    // Navigation
    const $toggler = $('#navbarToggler');
    const $mobileNav = $('#mobileNav');
    const $overlay = $('#mobileNavOverlay');
    const $body = $('body');

    $toggler.on('click', function () {
        $toggler.toggleClass('open');
        $mobileNav.toggleClass('open');
        $overlay.toggleClass('open');
        $body.toggleClass('mobile-nav-open');
    });

    $overlay.on('click', function () {
        $toggler.removeClass('open');
        $mobileNav.removeClass('open');
        $overlay.removeClass('open');
        $body.removeClass('mobile-nav-open');
    });

})

import { createIcons, Menu, FolderSearch, ClipboardClock, HandCoins, Info, Wrench, Handshake, FolderSync, ChartLine, MessagesSquare } from 'lucide';

createIcons({
    icons: {
        Menu,
        FolderSearch,
        ClipboardClock,
        HandCoins,
        Info,
        Wrench,
        Handshake,
        FolderSync,
        ChartLine,
        MessagesSquare
    }
});

